var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 19L13.4453 17.5",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4453 5.12595H9.95889C9.88797 4.68869 9.75722 4.30133 9.56664 3.96388C9.37606 3.62167 9.13894 3.33175 8.85528 3.09411C8.57163 2.85646 8.24808 2.67823 7.88465 2.55941C7.52564 2.43584 7.13783 2.37405 6.72121 2.37405C5.98105 2.37405 5.32509 2.57367 4.75335 2.97291C4.1816 3.3674 3.73396 3.94724 3.41041 4.71245C3.08686 5.47291 2.92509 6.40209 2.92509 7.5C2.92509 8.61692 3.08686 9.55799 3.41041 10.3232C3.73839 11.0837 4.18603 11.6587 4.75335 12.0485C5.32509 12.4335 5.97883 12.626 6.71456 12.626C7.12232 12.626 7.50348 12.5689 7.85805 12.4548C8.21706 12.336 8.53839 12.1625 8.82204 11.9344C9.11013 11.7063 9.35168 11.4259 9.5467 11.0932C9.74614 10.7605 9.88354 10.3802 9.95889 9.95247L12.4453 9.96673C12.3522 10.6606 12.1506 11.3118 11.8403 11.9202C11.5345 12.5285 11.1334 13.0656 10.637 13.5314C10.1406 13.9924 9.55999 14.3536 8.89517 14.615C8.23035 14.8717 7.4924 15 6.68132 15C5.48465 15 4.4165 14.7029 3.47689 14.1088C2.53728 13.5147 1.79711 12.6568 1.25639 11.5352C0.715673 10.4135 0.445312 9.06844 0.445312 7.5C0.445312 5.92681 0.717889 4.58175 1.26304 3.46483C1.80819 2.34316 2.55058 1.48527 3.49019 0.891159C4.4298 0.297053 5.49351 0 6.68132 0C7.43922 0 8.14393 0.114068 8.79545 0.342205C9.44697 0.570342 10.0276 0.905419 10.5373 1.34743C11.047 1.7847 11.4658 2.32177 11.7938 2.95865C12.1262 3.59078 12.3434 4.31321 12.4453 5.12595Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.888b61abdc9ccd5064ee42af0dd33937.svg";
export { ForwardRef as ReactComponent };